import {Type} from 'class-transformer';
import {Attachment} from '../Attachment';

export class DashboardCustomization {

  public welcomeText?: string;
  @Type(() => Attachment)
  public logo?: Attachment;
}
